import { CommonModule } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { RepresentacaoInstituicaoGestoraService } from '@app/features-modules/gestao-bolseiros/components/api/services';
import { ApiService } from '@core/providers/http';
import { MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { PasswordModule } from 'primeng/password';
import { Toast } from 'primeng/toast';

@Component({
  selector: 'app-redefinir-senha',
  imports: [CommonModule, ButtonModule, ReactiveFormsModule, DialogModule, InputTextModule, PasswordModule, Toast],
  providers: [ApiService, RepresentacaoInstituicaoGestoraService, MessageService, DialogService],
  templateUrl: './redefinir-senha.component.html',
  styleUrl: './redefinir-senha.component.scss',
  standalone: true
})
export class RedefinirSenhaComponent implements OnInit{

  redefinirSenhaForm!: FormGroup;
  private fb = inject(FormBuilder);
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  messageService = inject(MessageService);
  dialogService = inject(DialogService);
  UserNameRepresentante: string = '';

  redefinirSenhaService = inject(RepresentacaoInstituicaoGestoraService)

  constructor(){
    this.redefinirSenhaForm = this.fb.group({
      email: [{ value: '', disabled: true }, Validators.required],
      username: [{ value: '', disabled: true }, Validators.required],
      novasenha: ['', [Validators.required, Validators.minLength(6)]],
      confirmarSenha: ['', [Validators.required]],
    }, { validators: this.matchPasswordsValidator });
  }

  ngOnInit(): void {
    const rep = this.config?.data?.representante;
    if (rep) {
      this.redefinirSenhaForm.patchValue({
        email: rep.emailRepresentante || '',
        username: rep.nome || '',
      });
      this.UserNameRepresentante = rep.usernameRepresentante || '';
    }
  }

  
  matchPasswordsValidator(formGroup: FormGroup) {
    const senha = formGroup.get('novasenha')?.value;
    const confirmar = formGroup.get('confirmarSenha')?.value;
    return senha && confirmar && senha !== confirmar ? { senhaMismatch: true } : null;
  }

  onSubmit(): void {
    if (this.redefinirSenhaForm.invalid) {
      this.redefinirSenhaForm.markAllAsTouched();

      if (this.redefinirSenhaForm.errors?.['senhaMismatch']) {
        this.messageService.add({
          severity: 'warn',
          summary: 'Aviso',
          detail: 'As senhas não coincidem.',
        });
      }

      return;
    }

    const payload = {
      username: this.UserNameRepresentante,
      email: this.redefinirSenhaForm.getRawValue().email,
      novasenha: this.redefinirSenhaForm.getRawValue().novasenha,
    };
    console.log('Payload para redefinir senha:', payload);

    this.redefinirSenhaService.redefinirSenha(payload).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Sucesso',
          detail: 'Senha redefinida com sucesso!',
        });
        this.ref.close(payload);
      },
      error: (err) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Erro',
          detail: 'Erro ao redefinir senha.',
        });
        console.error('Erro ao redefinir senha:', err);
      },
    });
  }

  cancel() {
    this.ref?.close();
  }
}
